<h2 mat-dialog-title>Deactivate closing process</h2>
<mat-dialog-content [formGroup]="stopTrialForm">
    <p>Are you sure you want to deactivate closing process?</p>
    <p><strong>Note:</strong></p>
    <ul>
        <li>Data produced during the activation will be lost.</li>
        <li>The feature will be terminated at {{ endDate }}</li>
        <li>No charges will be made.</li>
    </ul>
    <mat-form-field style="width: 100%">
        <mat-label>Reason for deactivating closing process</mat-label>
        <textarea matInput formControlName="survey" rows="4"></textarea>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="closeDialog()">Cancel</button>
    <button mat-raised-button color="warn" (click)="stopFCP()">Deactivate</button>
</mat-dialog-actions>
